export { default as Table } from "./Table";
export * from "./Table.types";
